import axios from "../plugins/axios";

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const addNewEmployee = async ({ caseId, accountId, employee }) => {
    try {
        const response = await axios.post(
            `${apiUrl}/addemployee/${accountId}/${caseId}`,
            employee
        );
        console.log({ response });
        return response.data;
    } catch (error) {
        throw error;
    }
};

const editCaseEmployee = async ({ employee, caseId }) =>
    await axios.post(`${apiUrl}/editemployee/${caseId}`, employee);

const getAccountEmployees = async ({
    accountId,
    excludedEmployeeIds,
    limit,
    query
}) => {
    const paramExcludedEmployeeId = excludedEmployeeIds
        .map((id) => `excludedEmployeeIds=${id}&`)
        .join("");
    const paramQuery = query ? `&query=${query}` : '';
    const paramLimit = limit ? `&limit=${limit}` : '';
    try {
        const response = await axios.get(
            `${apiUrl}/getaccountemployees/${accountId}?${paramExcludedEmployeeId}${paramLimit}${paramQuery}`
        );
        return response.data;
    } catch (error) {
        console.error(error);
        return Promise.reject(
            error?.message || "Could not get Employees for Account"
        );
    }
};

const getEmployeeLinkedCases = async (employeeId) => {
    try {
        const response = await axios.get(
            `${apiUrl}/employees/${employeeId}/cases`
        );
        return response.data;
    } catch (e) {
        console.error(e);
        return Promise.reject(
            e?.message || "Could not get linked cases for employee."
        )
    }
}

const addExistingEmployee = async ({ caseId, employeeId }) => {
    var response = await axios.post(`${apiUrl}/addexistingemployee/${caseId}/${employeeId}`);
    return response.data;
}    

const deleteEmployee = async ({ caseId, employeeId }) =>
    await axios.delete(
        `${apiUrl}/deletecaseemployee/${caseId}/${employeeId}`
    );

const caseEmployeeService = {
    addNewEmployee,
    editCaseEmployee,
    getAccountEmployees,
    addExistingEmployee,
    deleteEmployee,
    getEmployeeLinkedCases,
};

export default caseEmployeeService;
